import { useState } from "react";
import { FaStar } from "react-icons/fa";
import { api1 } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import { toast } from "react-toastify";
import Like from "../../images/svgs/Like";
import UnLike from "../../images/svgs/UnLike";

const ReviewCard = ({
  reviewId,
  name,
  avatar,
  date,
  rating,
  recommendation,
  comment,
  mentorApproval,
  onApprovalUpdate,
}) => {
  const [localStatus, setLocalStatus] = useState(mentorApproval);

  const handleApproval = async (approval) => {
  try {
    const response = await api1.patch(`${API_ENDPOINTS.UPDATE_REVIEW_APPROVAL}/${reviewId}`, { approval });
    const updatedReview = response.data.review; 

    setLocalStatus(updatedReview.mentorApproval); 

    if (onApprovalUpdate) {
      onApprovalUpdate(reviewId, updatedReview.mentorApproval);
    }

    toast.success(`Review ${updatedReview.mentorApproval} successfully`);
  } catch (error) {
    console.error("Error updating review approval:", error);
    toast.error("Failed to update review status");
  }
};

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-4 border border-gray-200">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <img
            src={avatar}
            alt={name}
            className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
          />
        </div>

        {/* Review Details */}
        <div className="flex-1">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
            <div>
              <h4 className="font-semibold text-gray-900 text-sm md:text-base">
                {name}
              </h4>
              <p className="text-xs text-gray-500">Reviewed {date} ago</p>
            </div>

            {/* Rating */}
            <div className="mt-2 sm:mt-0 flex">
              {Array.from({ length: 5 }, (_, i) => (
                <span
                  key={i}
                  className={`text-lg ${
                    i < rating ? "text-yellow-500" : "text-gray-300"
                  }`}
                >
                  <FaStar />
                </span>
              ))}
            </div>
          </div>

          {/* Recommendation */}
          {recommendation && (
            <p className="text-green-500 font-medium flex items-center mt-2 gap-1 text-sm">
              <Like className="w-4" /> {recommendation}
            </p>
          )}

          {/* Comment */}
          <p className="text-gray-700 mt-2 text-sm">{comment}</p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-2">
            <div></div>
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
              {localStatus === "pending" ? (
                <>
                  <span className="text-gray-500 text-xs">Approve?</span>
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleApproval("approved")}
                      className="px-3 py-1 border-2 text-gray-700 border-gray-200 rounded hover:bg-gray-200 flex items-center gap-2 text-xs sm:text-sm"
                    >
                      <Like className="w-4" /> Yes
                    </button>
                    <button
                      onClick={() => handleApproval("rejected")}
                      className="px-3 py-1 border-2 text-gray-700 border-gray-200 rounded hover:bg-gray-200 flex items-center gap-2 text-xs sm:text-sm"
                    >
                      <UnLike className="w-4" /> No
                    </button>
                  </div>
                </>
              ) : (
                <span
                  className={`font-semibold uppercase text-xs ${
                    localStatus === "approved"
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {localStatus}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
